import React, { useState } from 'react';
import { useEffect } from 'react';
import { useParams } from '../../../../services/routing/useRouteInfo';
import { FormMode, FormView } from '../../../shared/view/form';
import { InfoCard } from '../../../shared/cards/infoCard';
import { Button } from '../../../shared/inputs/button';
import { css } from '../../../../services/css';


import styles from './zipcodeForm.module.css';


export const ZipcodeForm = () => {

    let { id } = useParams();

    const [showScheduleMoved, setShowScheduleMoved] = useState(localStorage.getItem('showScheduleMoved') !== 'false');

    const onDismiss = () => {
        setShowScheduleMoved(false);
        localStorage.setItem('showScheduleMoved', 'false')
    }

    const [len, setLen] = useState(id?.split(',')?.length ?? 0);

    useEffect(() => {
        setLen(id?.split(',')?.length ?? 0);
    }, [id]);

    return <FormView
        ids={id?.split(',').map(i => parseInt(i ?? ''))}
        resourceName={len > 1 ? 'Zip Codes' : 'Zip Code'}
        nameFunction={r => r?.zip + ', ' + r?.city}
        restEndpoint='locations/zipcodes'
        processData={d => { if (d.note === null) d.note = ''; return d; }}
        headElement={showScheduleMoved && <InfoCard title='Schedule editing moved'>
            To edit an individual schedule, view the zip code, and then click the three dots and select edit schedule. Edit the schedule by clicking the days. To bulk edit, select the zip codes from the list and click the schedule edit button, to the right of the delete button.
            <Button className={css('primary', styles.HideButton)} type='button' onClick={onDismiss}>Dismiss</Button>
        </InfoCard>}
        formMode={len === 0 ? FormMode.Add : FormMode.Edit}
        format={{
            'zip': {
                label: 'Zip Code',
                validate: v => !/^[0-9]{5}$/.test(v.zip) && ((len > 1 && v.zip !== null) || len <= 1)? 'Invalid zip code' : null
            },
            'city': {
                max: 50,
                label: 'County'
            },
            'acceptingNewPatients': {
                type: 'switch',
                default: true,
                forChangeLog: v => v.acceptingNewPatients === true ? 'Yes' : 'No',
                switchData: len > 1 ?  [
                    {
                        label: 'Ignored',
                        value: null
                    },
                    {
                        label: 'Yes',
                        value: true
                    },
                    {
                        label: 'No',
                        value: false
                    }
                ] : [
                    {
                        label: 'Yes',
                        value: true
                    },
                    {
                        label: 'No',
                        value: false
                    }
                ]
            },
            //Only edit notes individually
            ...(len <= 1 ? {
                'note': {
                    max: 4000,
                    rows: 4,
                    type: 'textarea',
                    required: false
                }
            } : {})
        }}
        listLocation='locations/zipcodes'
    />
}